import { graphql } from "../../generated";

export const exportCampaignResultsMutation = graphql(/* GraphQL */ `
    mutation ExportCampaignResults(
        $clientId: String!
        $campaignId: String!
        $params: ExportCampaignResultsParamsInput!
    ) {
        exportCampaignResults(clientId: $clientId, campaignId: $campaignId, params: $params)
    }
`);
